import script from "./HotspotDetailsItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./HotspotDetailsItem.vue?vue&type=script&lang=ts&setup=true"

import "./HotspotDetailsItem.vue?vue&type=style&index=0&id=3be34d7f&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be34d7f"]])

export default __exports__